module.exports = __webpack_public_path__ + "static/media/204-Kaffee_ID_32.2bcfa566.mp3";